import { useCallback, useState } from "react";
import "../global/basic.css"
import { API_URL } from "../shared/api";
import { useNavigate } from "react-router-dom";
import useBackupUser from "../shared/hooks/useBackupUser";



export default function StartNewGameComponent({onStart = () => {}}) {
  const navigate = useNavigate();

  const user = useBackupUser();

  const [newGameName, setNewGameName] = useState("");
  const [season, setSeason] = useState("");
  const [episode, setEpisode] = useState("");

  const [loading, setLoading] = useState(false);


  const updateSeason = useCallback((changeVal) => {
    setSeason(changeVal);
    setNewGameName(`1% Quiz - S${changeVal} F${episode}`)
  },[setNewGameName, episode])

  const updateEpisode = useCallback((changeVal) => {
    setEpisode(changeVal);
    setNewGameName(`1% Quiz - S${season} F${changeVal}`)
  },[setNewGameName, season])

  const onNewGameStarted = useCallback((id) => {
    onStart();
    navigate(`/account/${id}/play`);
    setSeason("");
    setEpisode("");
    setNewGameName("");
  }, [onStart, navigate, setEpisode, setSeason, setNewGameName]);

  const startNewGame = useCallback(() => {
    if(!newGameName || !user || loading)
      return
    setLoading(true);

    const id = user?.id;
    fetch(`${API_URL}/users/${id}/active-game`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: newGameName
    })
      .then(x => x.json())
      .then(() => onNewGameStarted(id))
      .catch(e => console.error("Error creating game: " + e.message))
      .finally(() => setLoading(false));
  }, [user, onNewGameStarted, newGameName, loading])


  const handleKeyDown = useCallback((e) => {
    if(e.key === "Enter") startNewGame()
  }, [startNewGame]);


  return (
    <div className="vertical-container center flex-1">
      <div className="horizontal-container center">
        <form className="vertical-container gap-1 top-margin " onSubmit={(e) => { e.preventDefault(); startNewGame(); }}>
            
            <div className="horizontal-container gap-1 center">
              <span>Staffel</span>
              <input className="decent-input primary center"
                type="number" value={season} onChange={(e) => updateSeason(e.target.value)} />
              <span>-</span>
              <span>Folge</span> 
              <input className="decent-input primary center" 
                type="number" value={episode} onChange={(e) => updateEpisode(e.target.value)} />
            </div>

            <input type="text" className="decent-input primary" placeholder="Name des neuen Spiels" required={true}
            value={newGameName} onChange={(e) => setNewGameName(e.target.value)} onKeyDown={handleKeyDown} />

            <button onClick={startNewGame} className=" top-margin">Starten</button>
        </form>
      </div>
    </div>
   );
}